import { z } from 'zod'

import {
  EmploymentStatus,
  Gender,
  OnBoardingStatus,
  VisibilityType
} from '../enums'

import { EducationHistorySchema, EmploymentHistorySchema } from './history'
import { LanguageLevelSchema } from './language.schema'
import { ListIndustrySchema } from './listItem.schema'
import { candidateSkillSchema } from './skill.schema'

const BaseCVSchema = z.object({
  id: z.string().nullable().optional(),
  candidateId: z.string().nullable().optional(),
  deltaCvId: z.string().nullable().optional(),
  deltaCandidateId: z.string().nullable().optional(),
  avatarUrl: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  contactInformation: z.string().email(),
  phone: z.string().nullable().optional(),
  country: z.string().nullable(),
  city: z.string().nullable(),
  educationHistory: EducationHistorySchema.array(),
  employmentHistory: EmploymentHistorySchema.array(),
  industries: ListIndustrySchema.array(),
  languages: LanguageLevelSchema.array(),
  dateOfBirth: z.string(),
  visibilityType: z
    .nativeEnum(VisibilityType)
    .optional()
    .default(VisibilityType.Active),

  expectedSalaryEuros: z.number(),
  trainingBudgetId: z.string().nullable(),
  trainingBudget: z.string().nullable().optional(),
  remoteWorkTypeId: z.string().nullable(),
  remoteWorkType: z.string().nullable().optional(),
  bonuses: z.string().array(),
  openToRelocation: z.boolean().nullable(),
  openToPartTime: z.boolean().nullable(),
  drivingLicence: z.boolean().nullable(),

  fileName: z.string().optional().nullable(),
  employmentStatus: z.nativeEnum(EmploymentStatus),
  gender: z.nativeEnum(Gender),
  autoApply: z.boolean().optional(),
  skills: candidateSkillSchema.array()
})

const CVSchema = BaseCVSchema.extend({
  employmentHistory: EmploymentHistorySchema.array().min(1),
  industries: ListIndustrySchema.array().min(1),
  expectedSalaryEuros: z.number().min(100),
  languages: LanguageLevelSchema.array().min(1),
  onboardingStatus: z.nativeEnum(OnBoardingStatus).optional().nullable()
})

export default CVSchema
